import { render } from "./MarketSize.vue?vue&type=template&id=076c13c6&scoped=true"
import script from "./MarketSize.vue?vue&type=script&lang=js"
export * from "./MarketSize.vue?vue&type=script&lang=js"

import "./MarketSize.vue?vue&type=style&index=0&id=076c13c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076c13c6"]])

export default __exports__